var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { defaultChartConfig, fontFamily, fontStyle } from '../chart.config';
export var configDoughnutChart = {
    doughnutChartType: 'doughnut',
    doughnutChartOptions: __assign({}, defaultChartConfig, { cutoutPercentage: 70, legend: {
            display: true,
            position: 'bottom',
            fontFamily: fontFamily,
            fontStyle: fontStyle,
            labels: {
                padding: 36
            }
        } })
};
